import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProductSubtypePageRoutingModule } from './product-subtype-routing.module';

import { ProductSubtypePage } from './product-subtype.page';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProductSubtypePageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [ProductSubtypePage],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ProductSubtypePageModule {}
